/**
 * useUIStore — Global UI state (drawers, overlays, command palette).
 *
 * Currently:
 *  - LauncherDrawer (Nova Solicitação / Gaveta Retrátil — Prompt 31)
 */
import { create } from 'zustand';

interface UIStoreState {
  // ─── Launcher Drawer ───────────────────────────
  isLauncherDrawerOpen: boolean;
  launcherSearchQuery: string;

  openLauncherDrawer: (query?: string) => void;
  closeLauncherDrawer: () => void;
  setLauncherSearchQuery: (query: string) => void;
}

export const useUIStore = create<UIStoreState>((set) => ({
  isLauncherDrawerOpen: false,
  launcherSearchQuery: '',

  openLauncherDrawer: (query) =>
    set({
      isLauncherDrawerOpen: true,
      launcherSearchQuery: typeof query === 'string' ? query : '',
    }),
  closeLauncherDrawer: () =>
    set({ isLauncherDrawerOpen: false, launcherSearchQuery: '' }),
  setLauncherSearchQuery: (query) =>
    set({ launcherSearchQuery: typeof query === 'string' ? query : '' }),
}));
